import type { QueryClient } from "@tanstack/react-query";

export const estimateQueryKeys = {
  all: ["estimates"] as const,
  lists: () => [...estimateQueryKeys.all, "list"] as const,
  list: (
    organizationId?: string,
    filters?: Record<string, unknown>,
    sort?: { field: string; direction: "asc" | "desc" },
    page?: number,
    limit?: number,
  ) =>
    [
      ...estimateQueryKeys.lists(),
      organizationId,
      filters ? JSON.stringify(filters) : undefined,
      sort,
      page,
      limit,
    ] as const,
  details: () => [...estimateQueryKeys.all, "detail"] as const,
  detail: (
    organizationId: string | undefined,
    estimateId: string | null | undefined,
    options?: {
      includeLineItems?: boolean;
      includeProject?: boolean;
      includeClient?: boolean;
      includeAnalysis?: boolean;
      includeComparisons?: boolean;
    },
  ) =>
    [
      ...estimateQueryKeys.details(),
      organizationId,
      estimateId ?? undefined,
      options,
    ] as const,
  lineItems: (estimateId: string) =>
    [...estimateQueryKeys.all, "line-items", estimateId] as const,
  notes: (estimateId: string) =>
    [...estimateQueryKeys.all, "notes", estimateId] as const,
  metrics: (organizationId?: string, filters?: Record<string, unknown>) =>
    [
      ...estimateQueryKeys.all,
      "metrics",
      organizationId,
      filters ? JSON.stringify(filters) : undefined,
    ] as const,
} as const;

export const estimateAvailabilityQueryKeys = {
  all: ["available-estimates"] as const,
  list: (organizationId?: string, clientId?: string) =>
    [...estimateAvailabilityQueryKeys.all, organizationId, clientId] as const,
} as const;

export function invalidateAllEstimateQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: estimateQueryKeys.all });
  queryClient.invalidateQueries({
    queryKey: estimateAvailabilityQueryKeys.all,
  });
}
